module.exports = __webpack_public_path__ + "img/5.a3701790.png";